import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

/**
 * Minimal footer for staff /workspace routes only.
 * The full marketing + customer links footer is {@link AppFooter}.
 */
type WorkspaceFooterProps = {
  hasSidebar?: boolean;
};

function WorkspaceFooter({ hasSidebar = false }: WorkspaceFooterProps) {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer className="w-full min-w-0 max-w-full overflow-x-clip border-t border-slate-200 bg-slate-100/90 text-slate-600">
      <div
        className={`flex w-full flex-col items-center justify-center gap-1.5 px-4 py-2.5 text-center sm:flex-row sm:flex-wrap sm:gap-x-3 sm:gap-y-0 sm:text-left sm:px-5 lg:px-6 ${
          hasSidebar ? 'md:ml-56' : 'mx-auto max-w-6xl'
        }`}
      >
        <span className="text-[11px] leading-snug">
          © {year} {t('layout.app_name')}. {t('footer.workspace_internal')}
        </span>
        <span className="hidden text-[11px] text-slate-400 sm:inline">·</span>
        <Link
          to="/"
          className="text-[11px] font-semibold text-brand-700 hover:text-brand-800 hover:underline"
        >
          {t('footer.workspace_open_storefront')}
        </Link>
      </div>
    </footer>
  );
}

export default WorkspaceFooter;
